import DS from 'ember-data';
import MF from 'ember-data-model-fragments';
import { computed } from '@ember/object';
import { notEmpty } from '@ember/object/computed';
export default MF.Fragment.extend({
  autoPrimary: DS.attr('string'),
  autoSecondary: DS.attr('string'),
  manual: DS.attr('string'),
  prioritizedSelector: computed('autoPrimary', 'manual', function () {
    return this.manual ? this.manual : this.autoPrimary;
  }),
  hasSelector: notEmpty('prioritizedSelector')
});